import React from 'react';
import CalculationPrint from '../components/ILCPSection/ILCPExternal/CalculationPrint';

const PrintCalculationPage = () => <CalculationPrint />;

export default PrintCalculationPage;
